<div class="tab-container" [style.width.px]="tabWidth * tabs.length">
    <div *ngFor="let tab of tabs" class="tab" [class.active]="tab === activeTab" (click)="onTabClicked(tab)">
        <a>{{tab.title}}</a>
    </div>
    <hr *ngIf="tabs && tabs.length && activeTab"
        [style.left.px]="tabWidth * activeTabIndex"
        [class.animate]="animationEnabled">
</div>
